// src/ga.js
import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;


let isInitialized = false;

export const initGA = () => {
  if (!isInitialized && GA_MEASUREMENT_ID) {
    try {
      ReactGA.initialize(GA_MEASUREMENT_ID, {
        debug: true,
        testMode: process.env.NODE_ENV !== 'production',
      });
      isInitialized = true;
      //console.log('GA successfully initialized with ID:', GA_MEASUREMENT_ID);
    } catch (error) {
      console.error('Failed to initialize GA:', error);
    }
  }
};


export const logPageView = () => {
  ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
};

export const logEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};
